export function getScheduleIndexRoute (state, getters) {
  if (getters.scheduleEnabled) return 'schedules'
  if (state.permissions.includes('edit_settings')) return 'shift-defaults'
  return null
}

export function getTimeOffIndexRoute (state, getters) {
  if (getters.timeOffEnabled) return 'timeoff-entries'
  if (state.permissions.includes('edit_settings')) return 'timeoff-defaults'
  return null
}

export function getPayrollIndexRoute (state, getters) {
  if (getters.payRunEnabled) return 'pay-run-list'
  if (getters.netPayEnabled) return 'net-pay-adjustment-list'
  if (state.permissions.includes('edit_settings')) return 'payroll-defaults'
  return null
}